import React, { useEffect } from 'react';
import { init as initApm } from '@elastic/apm-rum';
import TagManager from 'react-gtm-module';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import type { Session } from 'next-auth';
import { Provider } from 'next-auth/client';
import { ParallaxProvider } from 'react-scroll-parallax';
import VWO from '../components/global/vwo/Vwo';
import ApmTransaction from '../components/apm-transactions/ApmTransaction';
import './dynamic.scss';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';

const apm = initApm({
  serviceName: process.env.ELASTIC_APM_SERVICE_NAME,
  serverUrl: process.env.ELASTIC_APM_SERVER_URL,
  environment: process.env.ELASTIC_APM_ENVIRONMENT
});

const MyApp = ({ Component, pageProps }: AppProps<{ session?: Session }>) => {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: process.env.GOOGLE_TAG_MANAGER_ID || 'GTM-PNNNX5G'
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <ParallaxProvider>
      <Provider session={pageProps.session}>
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: '<!-- Version 3.0 -->' }}
        />
        <Head>
          <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          {process.env.USE_VWO && <VWO />}
          <script
            data-script="accrue-savings-embed"
            defer
            src="https://embed.accruesavings.com/main.js"
            data-merchant-id="e1eee9f3-146f-4ff4-9070-b1f643db40e1"
            data-placement=".pdp-content-well__accrue"
            data-triggers=".pdp-content-well__accrue"
          />
          <script
            async
            src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
            type="text/javascript"
            data-domain-script={process.env.ONE_TRUST_ID}
          />
          <script type="text/javascript">
            function OptanonWrapper() {`{}`}
          </script>
        </Head>
        <ApmTransaction apm={apm}>
          <Component {...pageProps} />
        </ApmTransaction>
      </Provider>
    </ParallaxProvider>
  );
};

export default MyApp;
